export default {
  en: {
    title: 'Settings',
    subtitle: 'Customize your account settings',
    beta: {
      title: 'Activate beta features',
      tooltip: 'Participate in new Videsk features in beta stage.',
      participate: 'Participate',
    },
    recording: {
      title: 'Recording',
      tooltip: 'Record calls automatically or manually',
      automatic: 'Automatic',
      manual: 'Manual',
      filename: 'Filename',
      alert: 'You can use a variables like:',
    },
    acd: {
      title: 'Automatic call distribution (ACD)',
      subtitle: 'Change distribution algorithm',
      model: 'ACD algorithm',
      default: 'Default',
      circular: 'Circular (waterfall)',
      maxTimeout: 'Enable maximum response time (in seconds)',
      rotateOnTimeout: 'Rotate agent after unanswered rings',
      rotateOnTimeoutHint: 'A returning customer is prioritized to the agent who already attended them. After this many unanswered rings the call is released to the rest of the segment.',
      enableDismiss: 'Enable dismiss incoming calls',
    },
    fileshare: {
      title: 'File sharing',
      subtitle: 'Adjust settings of file sharing',
      extensions: 'Allowed extensions (by default, all)',
      extensionsPlaceholder: 'Enter the extension then press enter',
      alertTitle: 'Security concerns',
      alertSubtitle: 'Consider restricting the extensions, by default agent and customer can send anything',
    },
    forms: {
      title: 'Forms settings',
      subtitle: 'Adjust the captcha provider for bots and spam protection',
      provider: 'Captcha provider',
      placeholder: 'Select a provider',
      alert: 'Set a captcha provider is mandatory, please contact us if you don\'t have it',
      alertDomains: 'Remember whitelist the domains where you will use the captcha service in the {provider} panel',
      siteKey: 'Site key',
      secret: 'Secret',
      resource: 'Resource CDN',
      projectId: 'Project ID',
      videskProvider: 'Videsk Captcha (recommended)',
      videskTitle: 'No keys required',
      videskDescription: 'Videsk Captcha is a privacy-first, proof-of-work captcha hosted by Videsk. It needs no site key, secret or domain whitelist, loads no third-party scripts and works inside any iframe, including cross-origin embeds.',
    },
    virtualBackground: {
      title: 'Virtual background',
      subtitle: 'Customize the company virtual backgrounds',
      placeholder: 'Enter a valid URL',
      alert: 'The URL needs to have public access (CORS) starting with https://',
      empty: 'No virtual backgrounds found, add new one.',
      slowLoading: 'The image hosting load too slow, more than 2 seconds. Took: {speed} seconds.'
    },
    privacy: {
      title: 'Privacy',
      subtitle: 'Adjust privacy settings',
      showName: 'Show agent full name to customers'
    },
    spyMode: {
      title: 'Realtime supervision',
      subtitle: 'Enable or disable realtime supervision',
      tooltip: 'When enabled, supervisors can see and listen to calls without the customer knowing.',
      enable: 'Enable realtime supervision',
      accepted: 'You have accepted the realtime supervision terms and conditions.',
      accept: 'Accept realtime supervision terms',
      alert: 'By enabling this feature, you agree to the terms and conditions of using realtime supervision.',
      terms: '1. Inform workers in advance about the monitoring system \n2. Obtain express consent from the worker \n3. Define specific purposes (quality control, training, security) \n4. Implement security measures to protect data \n5. Maintain proportionality between the objective and the level of monitoring',
    }
  },
  es: {
    title: 'Ajustes',
    subtitle: 'Personalice la configuración de su cuenta',
    beta: {
      title: 'Activar funciones beta',
      tooltip: 'Participe en nuevas funciones en estado beta.',
      participate: 'Participar',
    },
    recording: {
      title: 'Grabación',
      tooltip: 'Grabe las llamadas manual o automáticamente.',
      automatic: 'Automático',
      manual: 'Manual',
      filename: 'Nombre del archivo',
      alert: 'Puedes usar variables como:',
    },
    acd: {
      title: 'Distribuidor automático de llamadas (ACD)',
      subtitle: 'Cambiar algoritmo de distribución',
      model: 'Algoritmo ACD',
      default: 'Defecto',
      circular: 'Circular (cascada)',
      maxTimeout: 'Habilitar tiempo máximo de respuesta (en segundos)',
      rotateOnTimeout: 'Rotar ejecutivo tras timbres sin respuesta',
      rotateOnTimeoutHint: 'Un cliente recurrente se prioriza al ejecutivo que ya lo atendió. Tras esta cantidad de timbres sin respuesta, la llamada se libera al resto del segmento.',
      enableDismiss: 'Habilitar rechazo de llamadas entrantes',
    },
    fileshare: {
      title: 'Intercambio de archivos',
      subtitle: 'Modifique los ajustes del envío de archivos',
      extensions: 'Extensiones permitidas (por defecto, todas)',
      extensionsPlaceholder: 'Ingresa la extensión y luego presiona enter',
      alertTitle: 'Seguridad preventiva',
      alertSubtitle: 'Considera limitar archivo por extensiones, por defecto clientes y agentes pueden enviar lo que sea',
    },
    forms: {
      title: 'Ajustes de formularios',
      subtitle: 'Ajuste el proveedor de captcha para sus formularios',
      provider: 'Proveedor de captcha',
      placeholder: 'Seleccione un proveedor',
      alert: 'Configurar un proveedor de captcha es obligatorio',
      alertDomains: 'Recuerde por seguridad limitar su cuenta captcha a los dominios donde los utilizará en el panel de {provider}',
      siteKey: 'Llave de sitio',
      secret: 'Secreto',
      resource: 'CDN recurso',
      projectId: 'ID del proyecto',
      videskProvider: 'Videsk Captcha (recomendado)',
      videskTitle: 'No requiere llaves',
      videskDescription: 'Videsk Captcha es un captcha de prueba de trabajo alojado por Videsk que respeta la privacidad. No necesita llave de sitio, secreto ni lista de dominios, no carga scripts de terceros y funciona dentro de cualquier iframe, incluso embebidos entre dominios distintos.',
    },
    virtualBackground: {
      title: 'Fondos virtuales',
      subtitle: 'Personaliza los fondos virtuales de la empresa',
      placeholder: 'Enter a valid URL',
      alert: 'La URL debe ser de acceso público y comenzar con https://',
      empty: 'No se encontraron fondos virtuales, agregue uno nuevo.',
      slowLoading: 'La carga de la imagen tardó más de 2 segundos. Tomó: {speed} segundos.'
    },
    privacy: {
      title: 'Privacidad',
      subtitle: 'Ajustar configuraciones de privacidad',
      showName: 'Mostrar nombre completo del agente a los clientes'
    },
    spyMode: {
      title: 'Modo supervisión en vivo',
      subtitle: 'Habilitar o deshabilitar el modo de supervisión en vivo',
      tooltip: 'Cuando está habilitado, los supervisores pueden ver y escuchar llamadas sin que el cliente lo sepa.',
      enable: 'Habilitar modo de supervisión en vivo',
      accepted: 'Has aceptado los términos y condiciones del modo de supervisión en vivo.',
      accept: 'He leído y acepto expresamente los términos del modo de supervisión en vivo',
      alert: 'Al habilitar esta función, aceptas los términos y condiciones del uso del modo de supervisión en vivo.',
      terms: 'Al activar esta funcionalidad deberás cumplir con los siguientes puntos de aspecto legal con jurisdicción local: \n\n1. Informar previamente a los trabajadores sobre el sistema de monitoreo \n2. Obtener consentimiento expreso del trabajador \n3. Definir finalidades específicas (control de calidad, capacitación, seguridad) \n4. Mantener proporcionalidad entre el objetivo y el nivel de monitoreo \n5. Custodiar el acceso de supervisores mediante todos los mecanismos de protección proporcionados por Videsk \n6. Mantener la confidencialidad de los datos de los trabajadores y clientes \n7. Respetar las normativas locales sobre privacidad y protección de datos personales',
    },
  },
  fr: {
    title: 'Paramètres',
    subtitle: 'Personnalisez les paramètres de votre compte',
    beta: {
      title: 'Activer les fonctionnalités bêta',
      tooltip: 'Participez à de nouvelles fonctionnalités en phase bêta.',
      participate: 'Participer',
    },
    recording: {
      title: 'Enregistrement',
      tooltip: 'Enregistrez les appels manuellement ou automatiquement.',
      automatic: 'Automatique',
      manual: 'Manuel',
      filename: 'Nom du fichier',
      alert: 'Vous pouvez utiliser des variables telles que :',
    },
    acd: {
      title: 'Répartiteur automatique d\'appels (ACD)',
      subtitle: 'Changer l\'algorithme de répartition',
      model: 'Algorithme ACD',
      default: 'Par défaut',
      circular: 'Circulaire (cascade)',
      maxTimeout: 'Activer le délai de réponse maximum (en secondes)',
      rotateOnTimeout: 'Faire tourner l\'agent après des sonneries sans réponse',
      rotateOnTimeoutHint: 'Un client récurrent est prioritairement dirigé vers l\'agent qui l\'a déjà pris en charge. Après ce nombre de sonneries sans réponse, l\'appel est libéré vers le reste du segment.',
      enableDismiss: 'Activer le rejet des appels entrants',
    },
    fileshare: {
      title: 'Partage de fichiers',
      subtitle: 'Modifiez les paramètres d\'envoi de fichiers',
      extensions: 'Extensions autorisées (par défaut, toutes)',
      extensionsPlaceholder: 'Entrez l\'extension puis appuyez sur entrer',
      alertTitle: 'Sécurité préventive',
      alertSubtitle: 'Envisagez de limiter les fichiers par extensions, par défaut les clients et les agents peuvent envoyer tout ce qu\'ils veulent',
    },
    forms: {
      title: 'Paramètres des formulaires',
      subtitle: 'Configurez le fournisseur de captcha pour vos formulaires',
      provider: 'Fournisseur de captcha',
      placeholder: 'Sélectionnez un fournisseur',
      alert: 'Configurer un fournisseur de captcha est obligatoire',
      alertDomains: 'Pour des raisons de sécurité, n\'oubliez pas de limiter votre compte captcha aux domaines où il sera utilisé dans le panneau de {provider}',
      siteKey: 'Clé du site',
      secret: 'Secret',
      resource: 'Ressource CDN',
      projectId: 'ID du projet',
      videskProvider: 'Videsk Captcha (recommandé)',
      videskTitle: 'Aucune clé requise',
      videskDescription: 'Videsk Captcha est un captcha par preuve de travail hébergé par Videsk et respectueux de la vie privée. Il ne nécessite ni clé de site, ni secret, ni liste de domaines, ne charge aucun script tiers et fonctionne dans n\'importe quel iframe, y compris les intégrations inter-domaines.',
    },
    virtualBackground: {
      title: 'Arrière-plans virtuels',
      subtitle: 'Personnalisez les arrière-plans virtuels de l\'entreprise',
      placeholder: 'Entrez une URL valide',
      alert: 'L\'URL doit être accessible publiquement et commencer par https://',
      empty: 'Aucun arrière-plan virtuel trouvé, ajoutez un nouveau.',
      slowLoading: 'Le chargement de l\'image a pris plus de 2 secondes. Temps pris : {speed} secondes.'
    },
    privacy: {
      title: 'Confidentialité',
      subtitle: 'Ajuster les paramètres de confidentialité',
      showName: 'Afficher le nom complet de l\'agent aux clients'
    },
    spyMode: {
      title: 'Supervision en temps réel',
      subtitle: 'Activer ou désactiver la supervision en temps réel',
      tooltip: 'Lorsque cette fonction est activée, les superviseurs peuvent voir et écouter les appels sans que le client ne le sache.',
      enable: 'Activer la supervision en temps réel',
      accepted: 'Vous avez accepté les termes et conditions de la supervision en temps réel.',
      accept: 'Accepter les termes de la supervision en temps réel',
      alert: 'En activant cette fonctionnalité, vous acceptez les termes et conditions de l\'utilisation de la supervision en temps réel.',
      terms: '1. Informer les travailleurs à l\'avance sur le système de surveillance \n2. Obtenir le consentement explicite du travailleur \n3. Définir des finalités spécifiques (contrôle de qualité, formation, sécurité) \n4. Mettre en œuvre des mesures de sécurité pour protéger les données \n5. Maintenir la proportionnalité entre l\'objectif et le niveau de surveillance',
    },
}

};
